// react
import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Input, Divider, IconButton } from '@mui/material';
// components
import Iconify from '@/components/minimal/iconify';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 56,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingLeft: theme.spacing(2),
}));

// ----------------------------------------------------------------------

export default function CommentInput({ contentId, onCreate, disabled, disabledMessage }) {
  const [comment, setComment] = useState('');

  const handleCreate = () => {
    if (!comment) {
      return '';
    }
    if (onCreate && contentId) {
      onCreate(comment);
    }
    return setComment('');
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleCreate();
    }
  };

  return (
    <RootStyle>
      <Input
        fullWidth
        autoFocus
        value={comment}
        disableUnderline
        onKeyUp={handleKeyUp}
        onChange={(event) => setComment(event.target.value)}
        placeholder={!disabled ? 'Type a comment' : disabledMessage}
        disabled={disabled}
      />

      <Divider orientation="vertical" flexItem />

      <IconButton
        color="primary"
        disabled={!comment || disabled}
        onClick={handleCreate}
        sx={{ mx: 1 }}
      >
        <Iconify icon="ic:round-send" width={22} height={22} />
      </IconButton>
    </RootStyle>
  );
}
